module.exports.getPostLinkFromShareId = (shareId) => {
	return "https://www.linkedin.com/feed/update/" + shareId;
};
